const styles = {
    modal: (width: number) => ({
        width,
        background: '#ffffff',
        p: 3,
        borderRadius: 2,
        outline: 'none',
        maxHeight: '80vh',
        overflow: 'auto',
    }),
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '27px',
        color: '#3876AA',
        mb: 3,
        display: 'flex',
        justifyContent: 'space-between',
    },
    description: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#27344E',
        mb: 3,
    },
    modal_backdrop: {
        backgroundColor: '#00153333',
    },
    divider: {
        color: '#E0E4ED',
        marginTop: '16px',
        marginBottom: '32px',
    },
    close: {
        padding: 0,
    },
    formsModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};

export default styles;
